<div class="notifications-wrapper">
  <header class="mobile-app-bar">
    <!--    <app-icon color="var(&#45;&#45;slate-gray)" iconName="chevron-left" routerLink="/" size="18px"></app-icon>-->
    <span>&nbsp;</span>
    <h5 class="mobile-app-bar__heading" translate>Notifications</h5>
  </header>
  <div class="web-app-bar">
    <header class="flex-row-between-center">
      <h5 class="web-app-bar__heading" translate>Notifications</h5>
      <!--      <p class="web-app-bar__text" translate>Clear All</p>-->
    </header>
  </div>

  <!-- Main-body area -->
  <div class="notifications">
    @if (notifications$ | async; as notifications) {
      @if (notifications && notifications.length) {
        @for (notification of notifications | slice: 0 : limit; let i = $index; track notification.id + notification.notificationType + i) {
          <div class="notifications__item" id="{{ notification.notificationType }}">
            <div class="notifications__item__user-avatar background-loading-small">
              <img [alt]="" [appFetchProfileImage]="getMemberId(notification)" src="assets/images/placeholder.png" />
            </div>
            <div class="notifications__item__content">
              <h4 class="notifications__item__content__heading">{{ notification.firstName }} {{ notification.lastName }}</h4>
              {{ getNotificationText(notification.notificationType) }}
              <p class="notifications__item__content__description" (click)="openNotificationSectionDetails(notification)">{{ notification.title }}</p>
              <p class="notifications__item__content__time">{{ getTimeAgo(notification.createdAt) }}</p>
              <!-- Buttons for action -->

              <div class="flex-row-start-center mt-16">
                @for (action of getButtonActions(notification.notificationType); let i = $index; track action + i) {
                  <button
                    (click)="handleButtonClick(notification, action, notification.section)"
                    [ngClass]="action === ActionType.Accept ? 'button button-primary button-small ml-12' : 'button button-simple button-small'"
                    [translate]="action"
                  >
                    {{ action | humanize | translate }}
                  </button>
                }
              </div>
            </div>
          </div>
          <div class="ruler-1"></div>
        }

        @if (limit !== Infinity) {
          <div class="mt-26">
            <div class="web-buttons">
              <button (click)="showMore()" class="button button-simple button-full" translate>See more Notifications</button>
            </div>
            <div class="mobile-buttons">
              <button (click)="showMore()" class="button button-simple button-full" translate>View more</button>
            </div>
          </div>
        }
      } @else {
        <ng-container *ngTemplateOutlet="noRecord"></ng-container>
      }
    } @else {
      <ng-container *ngTemplateOutlet="loader"></ng-container>
    }
  </div>
</div>

<ng-template #loader>
  @if (isLoading) {
    <ngx-skeleton-loader [theme]="{ height: '140px', width: '420px', borderRadius: '8px' }" count="10"></ngx-skeleton-loader>
  }
</ng-template>

<ng-template #noRecord>
  <div class="noRecord">
    <p translate>You have no notifications</p>
  </div>
</ng-template>
